import { render, staticRenderFns } from "./wangdian.vue?vue&type=template&id=0515865c&scoped=true&"
import script from "./wangdian.vue?vue&type=script&lang=js&"
export * from "./wangdian.vue?vue&type=script&lang=js&"
import style0 from "./wangdian.vue?vue&type=style&index=0&id=0515865c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0515865c",
  null
  
)

export default component.exports